import React, { useMemo } from 'react';
import { Link, Text } from '@livechat/design-system-react-components';

import { Product } from 'types/product';
import { ProductDomain } from 'types/domains';
import { detectProduct } from 'helpers/product';

import { signupLegalInfo } from './styles';

const SignupLegalInfo: React.FC = () => {
  const product = detectProduct();

  const domain = useMemo(() => {
    switch (product) {
      case Product.HelpDesk:
        return ProductDomain.HelpDesk;
      case Product.ChatBot:
        return ProductDomain.ChatBot;
      case Product.OpenWidget:
        return ProductDomain.OpenWidget;
      case Product.KnowledgeBase:
        return ProductDomain.KnowledgeBase;
      case Product.TextApp:
        return ProductDomain.TextApp;
      case Product.LiveChat:
      case Product.PartnerProgram:
      default:
        return ProductDomain.LiveChat;
    }
  }, [product]);

  const getTermsUrl = (productDomain: string): string => {
    if (product === Product.PartnerProgram) {
      return 'https://www.livechat.com/legal/partner-program-terms/';
    }
    return `https://${productDomain}/legal/terms-of-use/`;
  };

  const getPpUrl = (productDomain: string): string =>
    `https://${productDomain}/legal/privacy-policy/`;

  return (
    <div css={signupLegalInfo}>
      <Text size="md">
        You agree to our{' '}
        <Link href={getTermsUrl(domain)} target="_blank" rel="noopener noreferrer" bold={false}>
          Terms of Use
        </Link>{' '}
        and{' '}
        <Link href={getPpUrl(domain)} target="_blank" rel="noopener noreferrer" bold={false}>
          Privacy Policy
        </Link>
      </Text>
    </div>
  );
};

export default SignupLegalInfo;
